import React from 'react'

const Jewelry = () => {
  return (
    <div>
      <h1>Hello</h1>
    </div>
  )
}

export default Jewelry

